import {
  ExpandableSection,
  SpaceBetween,
  Grid,
} from "@cloudscape-design/components-themed";
import { Dispatch, SetStateAction } from "react";
import { SettlementNoticeEmail } from "../../../features/api-interfaces";
import { formatLabel } from "../../../utils/format";
import InfoField from "../../UI/InfoField";
import { LABELS } from "../constants";

interface ISettlementNoticeReference {
  emailList: SettlementNoticeEmail[];
  isExpanded: boolean;
  setIsExpanded: Dispatch<SetStateAction<boolean>>;
}

/**
 * 入金口座情報照会・更新 精算額通知
 */
export const SettlementNoticeReference = (
  props: ISettlementNoticeReference
) => {
  const { emailList, isExpanded, setIsExpanded } = props;

  return (
    <ExpandableSection
      variant={"container"}
      headerText={formatLabel(LABELS.SETTLEMENT_NOTICE_TITLE, [
        emailList?.length ?? 0,
      ])}
      expanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
    >
      {emailList?.map((settlementNotice) => (
        <SpaceBetween
          key={settlementNotice?.ipid}
          direction={"vertical"}
          size={"xxs"}
        >
          <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
            <SpaceBetween direction={"horizontal"} size={"xxl"}>
              <InfoField
                direction={"vertical"}
                size={"xxs"}
                tag={"h4"}
                values={[LABELS.IPID]}
              />
              <InfoField
                direction={"vertical"}
                size={"xxs"}
                tag={"p"}
                values={[settlementNotice?.ipid]}
              />
            </SpaceBetween>
            <SpaceBetween direction={"horizontal"} size={"xxl"}>
              <InfoField
                direction={"vertical"}
                size={"xxs"}
                tag={"h4"}
                values={[LABELS.EMAIL]}
              />
              <InfoField
                direction={"vertical"}
                size={"xxs"}
                tag={"p"}
                values={[settlementNotice?.email]}
              />
            </SpaceBetween>
          </Grid>
        </SpaceBetween>
      ))}
    </ExpandableSection>
  );
};
